import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { toHttpParams } from '../http/http-params';
import { NotificationFilter, NotificationPage, UnreadSummary } from '../models/notification.models';

/** In-app notifications (/api/notifications): the bell count, the list, and marking one as read. */
@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiBaseUrl}/notifications`;

  /** Unread notifications per application code (CAPEX, MDM...), kept up to date by every unread-count read. */
  readonly byApplication = signal<Record<string, number>>({});

  unreadCount(): Observable<number> {
    return this.http.get<UnreadSummary>(`${this.url}/unread-count`).pipe(
      tap((summary) => this.byApplication.set(summary.byApplication ?? {})),
      map((summary) => summary.unreadCount),
    );
  }

  list(pageNumber = 1, pageSize = 20, filter: NotificationFilter = {}): Observable<NotificationPage> {
    return this.http.get<NotificationPage>(this.url, {
      params: toHttpParams({
        pageNumber,
        pageSize,
        status: filter.status && filter.status !== 'all' ? filter.status : undefined,
        applicationCode: filter.applicationCode ?? undefined,
      }),
    });
  }

  markRead(id: string): Observable<void> {
    return this.http.post<void>(`${this.url}/${id}/read`, {});
  }
}
